<template>
  <header class="communities__component">
    <div class="container__fw">
      <div class="container communities">
        <div class="left__wrapper">
          <h3>Local communities</h3>
          <div class="bottom-text">I'm part of in Mauritius</div>
        </div>
        <div class="right_wrapper">
          <div class="community">
            <a href="https://mscc.mu">
              <img
                v-if="getTheme == 'theme-1'"
                src="@/assets/mscc-logo-coloured.svg"
                alt
              />
              <img
                v-else-if="getTheme == 'theme-2'"
                src="@/assets/mscc-logo-inverted.svg"
                alt
              />
            </a>
          </div>
          <!-- <div class="community">
            <a href="https://lugm.org">
              <img src="@/assets/lugm_logo.png" alt />
            </a>
          </div> -->
          <div class="community">
            <a href="https://www.pmimauritius.com/">
              <img
                v-if="getTheme == 'theme-1'"
                src="@/assets/pmi_chapter_mauritius_logo.webp"
                alt
              />
              <img
                v-else-if="getTheme == 'theme-2'"
                src="@/assets/pmi_chapter_mauritius_logo-inverted.png"
                alt
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getTheme"]),
  },
};
</script>

<style lang="scss" scoped>
.communities__component {
  background: var(--color-grey);
}

.communities {
  display: grid;
  padding: 10px 0 calc(var(--gutter) * 2);
  grid-template-columns: 1fr 1fr;
  align-items: center;
  color: var(--color-text-dark);

  .left__wrapper {
    text-align: left;

    h3 {
      font-size: 35px;
      font-weight: 500;
      margin: 0;
    }

    .bottom-text {
      color: var(--color-text-light);
      margin-top: 5px;
    }
  }

  .right_wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .community {
      margin-right: var(--gutter);

      &:last-child {
        margin-right: 0;
      }

      a {
        img {
          height: 60px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .communities {
    .left__wrapper {
      h3 {
        font-size: 30px;
      }
    }

    .right_wrapper {
      .community {
        a {
          img {
            height: 40px;
          }
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .communities {
    grid-template-columns: 1fr;
    grid-gap: 40px;

    .left__wrapper {
      text-align: center;

      h3 {
        font-size: 25px;
      }
    }

    .right_wrapper {
      justify-content: center;
    }
  }
}
</style>
